import { lazy } from 'react'

// -------

import { routes } from 'config/app'
import { Rules } from 'config/permissions'

const ListPage = lazy(() => import('./List'))
const FormPage = lazy(() => import('./Form'))

// -------

const route = routes.baseAdminRoute + '/employees'

// -------

export const Api = {
  employees: '/employees',
  employee: '/employees/:id',
}

export const Routes = {
  index: route,
  form: `${route}/:id`
}

// COMPONENTS
export const Components = [
  { path: Routes.index, component: ListPage, permission: Rules.page.employee.index },
  { path: Routes.form,  component: FormPage, permission: Rules.page.employee.index }
]
